export default "__VITE_ASSET__uNIgbdGC__"